export default __webpack_public_path__ + "static/media/right.95ddc97c.png";